import React from 'react';
import RGL from 'react-grid-layout';
import { useIntl, getTranslatedText } from '@nile/components';
import {
  NUMBER,
  SUMMARY_TABLE
} from '@nile/reports/src/modules/charts/constants';
import {
  getDefaultChartType,
  getPossibleChartTypes
} from '@nile/reports/src/modules/charts/utils/chart-transformation';
import { SizeMe } from 'react-sizeme';
import EChart from '@nile/reports/src/modules/charts/components/subpages/EChart';
import NumberChart from '@nile/reports/src/modules/charts/components/subpages/NumberChart';
import SummaryTable from '@nile/reports/src/modules/charts/components/subpages/SummaryTable';
import {
  BuilderWrapper,
  Layout,
  El
} from '@nile/reports/src/modules/reports/components/subpages/NewReportGrid/styles';
import { TextStyle } from '@superops/ui-design-system';

const ResponsiveReactGridLayout = RGL;

const SharedReportGrid = (props) => {
  const { layout, isExport } = props;

  const intl = useIntl();

  return (
    <BuilderWrapper isExport={isExport} className="flex full-width">
      <Layout className="full-height p10 scroll">
        <SizeMe monitorHeight monitorWidth>
          {({ size }) => (
            <ResponsiveReactGridLayout
              className={`layout ${layout?.length === 0 ? 'no-layout' : ''}`}
              rowHeight={30}
              cols={12}
              height={size.height}
              width={size.width}
              layout={layout}
              compactType="vertical"
              measureBeforeMount
              useCSSTransforms
              preventCollision={false}
              isDroppable={false}
              isDraggable={false}
              isResizable={false}
            >
              {layout.map((l, i) => (
                <El key={l.i} isExport={isExport}>
                  <SizeMe
                    monitorHeight
                    monitorWidth
                    resizeDetectorStrategy="object"
                  >
                    {({ size }) => (
                      <div style={{ height: '100%' }}>
                        <div className="flex center chart-card bg-white p20">
                          <div
                            style={
                              l?.chart?.defaultChartType === SUMMARY_TABLE
                                ? {
                                    height: isExport
                                      ? 'auto'
                                      : size.height - 40,
                                    width: size.width - 40,
                                    overflow: 'auto'
                                  }
                                : {
                                    height: size.height - 40,
                                    width: size.width - 40
                                  }
                            }
                          >
                            {l?.chart?.name ? (
                              <div
                                className="chart-title ellipsis"
                                title={l.chart.name}
                              >
                                {l.chart.name}
                              </div>
                            ) : (
                              <TextStyle variation="subdued">
                                {getTranslatedText(intl, 'app.noData.message')}
                              </TextStyle>
                            )}
                            <RenderChart
                              item={l}
                              size={{
                                width: size.width - 40,
                                height: size.height - 70
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </SizeMe>
                </El>
              ))}
            </ResponsiveReactGridLayout>
          )}
        </SizeMe>
      </Layout>
    </BuilderWrapper>
  );
};

const RenderChart = ({ item, size }) => {
  const chartType =
    (getPossibleChartTypes(
      item?.chart?.metrics?.length,
      item?.chart?.groupBy?.length
    ).find((type) => type.name === item?.chart?.defaultChartType) &&
      item?.chart?.defaultChartType) ||
    getDefaultChartType(
      item?.chart?.metrics?.length,
      item?.chart?.groupBy?.length
    );
  if (chartType === NUMBER) {
    return <NumberChart data={item?.chartOptions} />;
  }
  if (chartType === SUMMARY_TABLE) {
    return (
      <SummaryTable
        data={item?.chartOptions}
        groups={item?.chart?.groupBy}
        metrics={item?.chart?.metrics}
        entity={item?.chart?.entity}
        chartRawData={item?.chartRawData}
      />
    );
  }
  return (
    <EChart
      chartOptions={item?.chartOptions}
      internalName={item?.chart?.internalName}
      opts={{ height: size.height, width: size.width, renderer: 'svg' }}
    />
  );
};

export default SharedReportGrid;
